import { useContext } from 'react';
import { ProductContext } from './ProductCard';

import styles from '../styles/styles.module.css'
import noImage from '../assets/no-image.jpg';

export interface Props {
    miniatura?: string;
    className?: string;
    style?: React.CSSProperties
}


export const

    ProductImage = ({ miniatura, className, style }: Props) => {

        const { product } = useContext(ProductContext);
        let imgToShow: string | null;

        if (product.miniatura == null) {
            imgToShow = noImage;
        } else {
            imgToShow = product.miniatura
        }
        return (
            <img
                className={`${styles.productImg} ${className}`}
                src={imgToShow!}
                style={style}
                alt="Producto"
            />
        );
    }